import Photo from "../Photo";
import { Container } from "./style";

const PhotoIsolated = ({photos}) => {

    return (
        <Container>
            {photos.map((photo, key) => {
                return <Photo key = {key} photo = {photo} />
            })}
           
        </Container>
    );
}

export default PhotoIsolated;